import { IdenticalTraceFilter } from "../../../param/generalSearchFilter";
import { filter } from "../commonLoop";
import { Result } from "../generalSearchResult";

export const identicalTraceFilter = async ({
  query,
  result,
  workerContext,
}: {
  query: IdenticalTraceFilter;
  result: Result;
  workerContext: any;
}) => {
  const {
    leftTraceIndex = 1,
    rightTraceIndex = 1,
    leftTraceType = "current",
    rightTraceType = "previous",
    compare = "nonIdentical",
  } = query;

  return filter(workerContext, result, (e) => {
    let flag = false;
    const leftTrace =
      leftTraceType === "current"
        ? e.currentWord
        : leftTraceType === "previous"
        ? e.trace[e.trace.length - leftTraceIndex - 1]
        : e.trace[leftTraceIndex - 1];
    const rightTrace =
      rightTraceType === "current"
        ? e.currentWord
        : rightTraceType === "previous"
        ? e.trace[e.trace.length - rightTraceIndex - 1]
        : e.trace[rightTraceIndex - 1];
    if (compare === "identical") {
      flag =
        leftTrace !== undefined &&
        rightTrace !== undefined &&
        leftTrace === rightTrace;
    } else if (compare === "nonIdentical") {
      flag =
        leftTrace !== undefined &&
        rightTrace !== undefined &&
        leftTrace !== rightTrace;
    }
    return flag;
  });
};
